(function () {
  'use strict';

  var sbbNamespace = window.__SBB__ = window.__SBB__ || {};
  var ScaleBarBuilder = sbbNamespace.ScaleBarBuilder;
  var clamp = sbbNamespace.clamp;
  var parseNumber = sbbNamespace.parseNumber;
  var toFixedTrim = sbbNamespace.toFixedTrim;
  var tagTypes = sbbNamespace.tagTypes;
  var aprilTagByValue = sbbNamespace.aprilTagByValue;
  var circularByValue = sbbNamespace.circularByValue;
  var mmPerCm = sbbNamespace.mmPerCm;
  var mmPerIn = sbbNamespace.mmPerIn;
  var commandUnitOptions = sbbNamespace.commandUnitOptions;
  if (!ScaleBarBuilder || !clamp || !parseNumber || !toFixedTrim || !tagTypes || !aprilTagByValue || !circularByValue || !mmPerCm || !mmPerIn || !commandUnitOptions) {
    return;
  }

  ScaleBarBuilder.prototype.buildUsedTagCsvText = function () {
    var rows = this.getScaleBarCoordinateRows(this.getActiveTags()).sort(function (a, b) {
      return a.id - b.id;
    });
    var lines = ['Tag ID,X,Y,Z'];
    for (var i = 0; i < rows.length; i += 1) {
      var row = rows[i];
      lines.push([
        row.displayCode || row.id,
        this.formatCommandCoordinate(row.xMm),
        this.formatCommandCoordinate(row.yMm),
        this.formatCommandCoordinate(row.zMm)
      ].join(','));
    }
    return lines.join('\n');
  };

  ScaleBarBuilder.prototype.refreshUsedTagCsvDisplay = function () {
    if (!this.controls || !this.controls.usedTagCsv) {
      return;
    }
    this.controls.usedTagCsv.value = this.buildUsedTagCsvText();
  };

  ScaleBarBuilder.prototype.downloadUsedTagCsv = function () {
    this.recordCurrentTagsAsUsed(this.getActiveTags());
    var csvText = this.buildUsedTagCsvText();
    var blob = new Blob([csvText], { type: 'text/csv;charset=utf-8' });
    var url = URL.createObjectURL(blob);
    var link = document.createElement('a');
    var scope = this.getCurrentTagScopeKey().replace(/\|/g, '-');
    link.href = url;
    link.download = 'used-tags-' + scope + '.csv';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    this.refreshUsedTagCsvDisplay();
    this.setStatus('Used tag CSV downloaded.', false);
  };

  ScaleBarBuilder.prototype.downloadMetashapeScript = function () {
    var tags = this.getActiveTags();
    if (!Array.isArray(tags) || !tags.length) {
      this.setStatus('No tags available for Metashape script export.', true);
      return;
    }
    var scriptText = this.buildMetashapeScaleScript(tags);
    if (!scriptText) {
      this.setStatus('Unable to generate Metashape script for the current canvas.', true);
      return;
    }
    var blob = new Blob([scriptText], { type: 'text/x-python;charset=utf-8' });
    var url = URL.createObjectURL(blob);
    var link = document.createElement('a');
    var scope = this.getCurrentTagScopeKey().replace(/\|/g, '-');
    link.href = url;
    link.download = 'metashape-scale-assignment-' + scope + '.py';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    this.setStatus('Metashape script downloaded.', false);
  };

  ScaleBarBuilder.prototype.getCommandUnitOption = function () {
    var mode = this.sanitizeCommandUnitMode(this.state.commandUnitMode);
    for (var i = 0; i < commandUnitOptions.length; i += 1) {
      if (commandUnitOptions[i].value === mode) {
        return commandUnitOptions[i];
      }
    }
    return commandUnitOptions[0];
  };

  ScaleBarBuilder.prototype.mmToCommandUnits = function (distanceMm) {
    var option = this.getCommandUnitOption();
    var mmPerUnit = Math.max(0.000001, parseNumber(option.mmPerUnit, 1000));
    return parseNumber(distanceMm, 0) / mmPerUnit;
  };

  ScaleBarBuilder.prototype.formatCommandCoordinate = function (distanceMm) {
    var units = this.mmToCommandUnits(distanceMm);
    var minDp = 4;
    var maxDp = 8;
    var out = Number(units).toFixed(maxDp);
    if (out.indexOf('.') !== -1) {
      while (out.charAt(out.length - 1) === '0' && out.split('.')[1].length > minDp) {
        out = out.slice(0, -1);
      }
      if (out.charAt(out.length - 1) === '.') {
        out += '0'.repeat(minDp);
      }
    }
    if (/^-0(\.0+)?$/.test(out)) {
      out = out.replace(/^-/, '');
    }
    return out;
  };

  ScaleBarBuilder.prototype.getTagDisplayCode = function (tagId) {
    if (this.state.tagType === 'circular' && this.state.tagFamily && this.state.tagFamily.indexOf('metashape-') === 0) {
      return 'target ' + String(Math.max(0, Math.round(parseNumber(tagId, 0))) + 1);
    }
    if (this.state.tagType === 'apriltag') {
      return this.formatAprilTagCodeId(tagId);
    }
    if (this.state.tagType === 'circular') {
      var circularCode = this.formatCircularTagCodeId(tagId, this.state.tagFamily);
      if (circularCode) {
        return circularCode;
      }
    }
    return 'ID ' + String(Math.max(0, Math.round(parseNumber(tagId, 0))));
  };

  ScaleBarBuilder.prototype.formatAprilTagCodeId = function (tagId) {
    var padByFamily = {
      '16h5': 2,
      '25h7': 2,
      '25h9': 2,
      '36h10': 3,
      '36h11': 3,
      'circle21h7': 2,
      'standard41h12': 3,
      'standard52h13': 4
    };

    var family = this.state.tagFamily || 'apriltag';
    var width = 0;
    if (this.isRealityScanAprilTagParityActive(family)) {
      var rsCodebook = this.getRealityScanAprilTagCodebook(family);
      if (rsCodebook && Array.isArray(rsCodebook.validLabelIds) && rsCodebook.validLabelIds.length) {
        var maxLabel = 0;
        for (var i = 0; i < rsCodebook.validLabelIds.length; i += 1) {
          maxLabel = Math.max(maxLabel, Math.max(0, Math.round(parseNumber(rsCodebook.validLabelIds[i], 0))));
        }
        width = Math.max(2, maxLabel.toString(16).length);
      }
    }
    if (!width) {
      var officialFamily = this.getOfficialAprilTagFamily(family);
      if (officialFamily && Array.isArray(officialFamily.codes) && officialFamily.codes.length) {
        width = Math.max(2, (officialFamily.codes.length - 1).toString(16).length);
      }
    }
    if (!width) {
      width = padByFamily[family] || 3;
    }
    var hex = Math.max(0, Math.round(tagId)).toString(16).toLowerCase();
    while (hex.length < width) {
      hex = '0' + hex;
    }
    return family + ':' + hex;
  };

  ScaleBarBuilder.prototype.formatCircularTagCodeId = function (tagId, familyValue) {
    var family = String(familyValue || this.state.tagFamily || '');
    var codebook = this.getRealityScanCircularCodebook(family);
    if (!codebook) {
      return '';
    }

    var resolvedLabelId = Math.max(0, Math.round(parseNumber(tagId, 0)));
    var resolved = this.resolveRealityScanCircularCode(resolvedLabelId, family);
    if (resolved && Number.isFinite(parseNumber(resolved.labelId, NaN))) {
      resolvedLabelId = Math.max(0, Math.round(parseNumber(resolved.labelId, resolvedLabelId)));
    }

    var segments = Math.max(1, Math.round(parseNumber(codebook.segments, 0)));
    var ringPrefix = codebook.ringMode === 'dual' ? '2x' : '1x';
    var width = Math.max(1, Math.ceil(segments / 4));
    var hex = resolvedLabelId.toString(16).toLowerCase();
    while (hex.length < width) {
      hex = '0' + hex;
    }
    return ringPrefix + String(segments) + ':' + hex;
  };

  ScaleBarBuilder.prototype.getTagTypeLabel = function () {
    for (var i = 0; i < tagTypes.length; i += 1) {
      if (tagTypes[i].value === this.state.tagType) {
        return tagTypes[i].label;
      }
    }
    return this.state.tagType;
  };

  ScaleBarBuilder.prototype.getTagFamilyLabel = function () {
    var family = this.state.tagType === 'apriltag'
      ? aprilTagByValue[this.state.tagFamily]
      : circularByValue[this.state.tagFamily];
    return family ? family.label : this.state.tagFamily;
  };

  ScaleBarBuilder.prototype.getRealityScanControlPointName = function (tag) {
    if (!tag) {
      return '';
    }
    if (this.state.tagType === 'circular' && this.state.tagFamily && this.state.tagFamily.indexOf('metashape-') === 0) {
      return 'target ' + String(Math.max(0, Math.round(parseNumber(tag.id, 0))) + 1);
    }
    if (this.state.tagType === 'apriltag') {
      return this.getTagDisplayCode(tag.id);
    }
    if (this.state.tagType === 'circular' && this.getRealityScanCircularCodebook(this.state.tagFamily)) {
      return this.getTagDisplayCode(tag.id);
    }
    return String(Math.max(0, Math.round(parseNumber(tag.id, 0))));
  };

  ScaleBarBuilder.prototype.escapeCliValue = function (value) {
    return String(value == null ? '' : value).replace(/"/g, '\'').trim();
  };

  ScaleBarBuilder.prototype.escapePythonString = function (value) {
    return String(value == null ? '' : value).replace(/\\/g, '\\\\').replace(/'/g, "\\'");
  };

  ScaleBarBuilder.prototype.getScaleBarCoordinateRows = function (tags) {
    if (!Array.isArray(tags) || tags.length === 0) {
      return [];
    }
    var origin = this.getOriginTag() || tags[0];
    var unitOption = this.getCommandUnitOption();
    var rows = [];
    for (var i = 0; i < tags.length; i += 1) {
      var tag = tags[i];
      var dxMm = tag.xMm - origin.xMm;
      var dyMm = origin.yMm - tag.yMm;
      var dzMm = 0;
      rows.push({
        id: Math.max(0, Math.round(parseNumber(tag.id, 0))),
        displayCode: this.getTagDisplayCode(tag.id),
        xMm: dxMm,
        yMm: dyMm,
        zMm: dzMm,
        xUnits: this.mmToCommandUnits(dxMm),
        yUnits: this.mmToCommandUnits(dyMm),
        zUnits: this.mmToCommandUnits(dzMm),
        unitsLabel: unitOption.label
      });
    }
    return rows;
  };

  ScaleBarBuilder.prototype.getMetashapeTargetTypeConstant = function () {
    var map = {
      'metashape-12bit': 'CircularTarget12bit',
      'metashape-14bit': 'CircularTarget14bit',
      'metashape-16bit': 'CircularTarget16bit',
      'metashape-20bit': 'CircularTarget20bit',
      '16h5': 'AprilTag16h5',
      '25h9': 'AprilTag25h9',
      '36h10': 'AprilTag36h10',
      '36h11': 'AprilTag36h11',
      'circle21h7': 'AprilTagCircle21h7',
      'standard41h12': 'AprilTagStandard41h12',
      'standard52h13': 'AprilTagStandard52h13'
    };
    return map[this.state.tagFamily] || (this.state.tagType === 'apriltag' ? 'AprilTag36h11' : 'CircularTarget16bit');
  };

  ScaleBarBuilder.prototype.buildMetashapeScaleScript = function (tags) {
    var rows = this.getScaleBarCoordinateRows(tags);
    if (!rows.length) {
      return '';
    }
    var commandUnit = this.getCommandUnitOption();
    var targetType = this.getMetashapeTargetTypeConstant();
    var lines = [];
    lines.push('import Metashape');
    lines.push('');
    lines.push('doc = Metashape.app.document');
    lines.push('chunk = doc.chunk');
    lines.push('if chunk is None:');
    lines.push("    raise RuntimeError('No active chunk.')");
    lines.push('');
    lines.push('# Detect coded targets (safe to keep even if targets already exist).');
    lines.push('chunk.detectMarkers(');
    lines.push('    target_type=Metashape.' + targetType + ',');
    lines.push('    tolerance=50,');
    lines.push('    filter_mask=False,');
    lines.push('    inverted=False,');
    lines.push('    merge_markers=True');
    lines.push(')');
    lines.push('');
    lines.push('# Scale-bar control coordinates in command units, relative to HOME.');
    lines.push('# ' + commandUnit.label + '.');
    lines.push('points = [');
    for (var i = 0; i < rows.length; i += 1) {
      var row = rows[i];
      var pointName = this.escapePythonString('target ' + String(row.id + 1));
      var display = this.escapePythonString(row.displayCode);
      lines.push(
        "    {'id': " + row.id +
        ", 'name': '" + pointName +
        "', 'display': '" + display +
        "', 'x': " + this.formatCommandCoordinate(row.xMm) +
        ", 'y': " + this.formatCommandCoordinate(row.yMm) +
        ", 'z': " + this.formatCommandCoordinate(row.zMm) +
        '},'
      );
    }
    lines.push(']');
    lines.push('');
    lines.push('def _marker_candidates(point):');
    lines.push("    base = str(point['id'])");
    lines.push("    cands = [point['name'], point['display'], base, 'target ' + str(int(base) + 1), 'ID ' + base]");
    lines.push('    # Some marker sheets are 1-based.');
    lines.push('    try:');
    lines.push('        cands.append(str(int(base) + 1))');
    lines.push('    except Exception:');
    lines.push('        pass');
    lines.push('    # Preserve order while removing duplicates.');
    lines.push('    out = []');
    lines.push('    seen = set()');
    lines.push('    for value in cands:');
    lines.push('        value = str(value).strip()');
    lines.push('        if not value or value in seen:');
    lines.push('            continue');
    lines.push('        seen.add(value)');
    lines.push('        out.append(value)');
    lines.push('    return out');
    lines.push('');
    lines.push('def _find_marker(chunk, candidates):');
    lines.push('    for marker in chunk.markers:');
    lines.push("        label = (marker.label or '').strip()");
    lines.push('        if label in candidates:');
    lines.push('            return marker');
    lines.push('    return None');
    lines.push('');
    lines.push('assigned = 0');
    lines.push('for point in points:');
    lines.push('    candidates = _marker_candidates(point)');
    lines.push('    marker = _find_marker(chunk, candidates)');
    lines.push('    if marker is None:');
    lines.push("        print(f\"Marker not found for id={point['id']} candidates={candidates}\")");
    lines.push('        continue');
    lines.push("    marker.reference.location = Metashape.Vector([point['x'], point['y'], point['z']])");
    lines.push('    marker.reference.enabled = True');
    lines.push('    marker.enabled = True');
    lines.push('    assigned += 1');
    lines.push('');
    lines.push('chunk.updateTransform()');
    lines.push("print(f'Assigned {assigned}/{len(points)} marker references.')");
    return lines.join('\n');
  };

  ScaleBarBuilder.prototype.buildRealityScanScaleCommand = function (tags) {
    var rows = this.getScaleBarCoordinateRows(tags);
    if (!rows.length) {
      return '';
    }
    var command = ['-detectMarkers'];
    for (var i = 0; i < rows.length; i += 1) {
      var row = rows[i];
      var cpName = this.escapeCliValue(this.getRealityScanControlPointName({ id: row.id }));
      if (!cpName) {
        continue;
      }
      command.push('-selectControlPoint "' + cpName + '"');
      command.push('-editControlPointSelection "gpName=' + cpName + '"');
      command.push('-editControlPointSelection "gpType=1"');
      command.push('-editControlPointSelection "gpEnabled=true"');
      command.push('-editControlPointSelection "gpP1=' + this.formatCommandCoordinate(row.xMm) + '"');
      command.push('-editControlPointSelection "gpP2=' + this.formatCommandCoordinate(row.yMm) + '"');
      command.push('-editControlPointSelection "gpP3=' + this.formatCommandCoordinate(row.zMm) + '"');
    }
    return command.join(' ');
  };

  ScaleBarBuilder.prototype.buildRealityScanDistanceCommand = function (tags) {
    var active = Array.isArray(tags) ? tags : [];
    if (!active.length) {
      return '';
    }
    var edges = this.getDistanceEdges(active);
    var command = ['-detectMarkers'];
    for (var i = 0; i < edges.length; i += 1) {
      var edge = edges[i];
      var tagA = active[edge.a];
      var tagB = active[edge.b];
      if (!tagA || !tagB) {
        continue;
      }
      var nameA = this.escapeCliValue(this.getRealityScanControlPointName(tagA));
      var nameB = this.escapeCliValue(this.getRealityScanControlPointName(tagB));
      if (!nameA || !nameB) {
        continue;
      }
      var dx = tagB.xMm - tagA.xMm;
      var dy = tagB.yMm - tagA.yMm;
      var distanceMm = Math.sqrt(dx * dx + dy * dy);
      var distanceUnits = this.mmToCommandUnits(distanceMm);
      command.push('-defineDistance "' + nameA + '" "' + nameB + '" "' + this.formatCoordinate(distanceUnits, 'metric', { minDp: 4, maxDp: 8 }) + '"');
    }
    return command.join(' ');
  };

  ScaleBarBuilder.prototype.getSoftwareScaleCommandOutput = function (tags) {
    var preset = this.state.softwarePreset;
    if (preset === 'realitycapture') {
      this.state.realityScanOutputMode = this.sanitizeRealityScanOutputMode(this.state.realityScanOutputMode);
      if (this.state.realityScanOutputMode === 'distance') {
        return this.buildRealityScanDistanceCommand(tags);
      }
      return this.buildRealityScanScaleCommand(tags);
    }
    if (preset === 'metashape') {
      return this.buildMetashapeScaleScript(tags);
    }
    if (preset === 'zephyr') {
      return '3DF Zephyr preset selected. Command output is currently implemented for Reality Scan and Metashape presets only.';
    }
    return 'Select a supported software preset (Reality Scan or Metashape) to generate assignment output.';
  };

  ScaleBarBuilder.prototype.updateSoftwareCommandOutput = function (tags) {
    if (!this.controls || !this.controls.commandOutput) {
      return;
    }
    var output = this.getSoftwareScaleCommandOutput(tags);
    this.controls.commandOutput.value = output;
    if (this.controls.exportCommandOutput) {
      this.controls.exportCommandOutput.value = output;
    }
    this.refreshUsedTagCsvDisplay();
  };

  ScaleBarBuilder.prototype.sanitizeExportPdfSettings = function (settings) {
    var raw = settings && typeof settings === 'object' ? settings : {};
    var format = String(raw.format || 'pdf').toLowerCase();
    if (format !== 'png' && format !== 'jpg') {
      format = 'pdf';
    }
    return {
      dpi: Math.round(clamp(parseNumber(raw.dpi, 300), 96, 1200)),
      mode: raw.mode === 'bitmap' ? 'bitmap' : 'hybrid-vector',
      format: format
    };
  };

  ScaleBarBuilder.prototype.getExportPdfSettings = function () {
    this.state.exportPdfSettings = this.sanitizeExportPdfSettings(this.state.exportPdfSettings);
    return this.state.exportPdfSettings;
  };

  ScaleBarBuilder.prototype.isExportPdfModalOpen = function () {
    return !!(this.controls && this.controls.exportOverlay && !this.controls.exportOverlay.hidden);
  };

  ScaleBarBuilder.prototype.setExportPreviewStatus = function (message, isError) {
    if (!this.controls || !this.controls.exportPreviewStatus) {
      return;
    }
    this.controls.exportPreviewStatus.textContent = message || '';
    this.controls.exportPreviewStatus.classList.toggle('is-error', !!isError);
  };

  ScaleBarBuilder.prototype.syncExportModalControlsFromState = function () {
    if (!this.controls) {
      return;
    }
    var settings = this.getExportPdfSettings();
    if (this.controls.exportPdfDpi) {
      this.controls.exportPdfDpi.value = String(settings.dpi);
    }
    if (this.controls.exportPdfMode) {
      this.controls.exportPdfMode.value = settings.mode;
    }
    if (this.controls.exportFormat) {
      this.controls.exportFormat.value = settings.format;
    }
    this.updateExportModalModeFieldState();
  };

  ScaleBarBuilder.prototype.updateExportModalModeFieldState = function () {
    if (!this.controls || !this.controls.exportPdfMode) {
      return;
    }
    var settings = this.getExportPdfSettings();
    var isPdf = settings.format === 'pdf';
    this.controls.exportPdfMode.disabled = !isPdf;
    this.controls.exportPdfMode.title = isPdf ? '' : 'Export Mode applies to PDF format only.';
  };

  ScaleBarBuilder.prototype.updateExportPdfEffectiveDpiNote = function () {
    if (!this.controls || !this.controls.exportPdfEffectiveDpi) {
      return;
    }
    var settings = this.getExportPdfSettings();
    var paper = this.getPaper();
    var safeDpi = this.getSafeExportDpi(settings.dpi, paper);
    var formatLabel = String(settings.format || 'pdf').toUpperCase();
    var text = 'Format: ' + formatLabel + '. ';
    if (settings.format === 'pdf') {
      var modeLabel = settings.mode === 'bitmap' ? 'Bitmap' : 'Hybrid Vector';
      text += 'Mode: ' + modeLabel + '. ';
    }
    text += 'Effective DPI: ' + Math.round(safeDpi) + '.';
    if (safeDpi < settings.dpi) {
      text += ' Requested ' + Math.round(settings.dpi) + ' DPI was limited by device canvas constraints.';
    }
    this.controls.exportPdfEffectiveDpi.textContent = text;
    this.updateExportModalModeFieldState();
  };

  ScaleBarBuilder.prototype.openExportPdfModal = function () {
    if (!this.controls || !this.controls.exportOverlay) {
      this.exportPdfFromModalSettings();
      return;
    }
    var commandTags = this.getActiveTags();
    this.updateSoftwareCommandOutput(commandTags);
    this.syncExportModalControlsFromState();
    this.updateExportPdfEffectiveDpiNote();
    this.controls.exportOverlay.hidden = false;
    this.isExportModalOpen = true;
    this.queueExportPdfPreview();
  };

  ScaleBarBuilder.prototype.closeExportPdfModal = function () {
    if (!this.controls || !this.controls.exportOverlay) {
      return;
    }
    this.controls.exportOverlay.hidden = true;
    this.isExportModalOpen = false;
    if (this.exportPreviewDebounceTimer) {
      clearTimeout(this.exportPreviewDebounceTimer);
      this.exportPreviewDebounceTimer = null;
    }
    if (this.exportDpiInputDebounceTimer) {
      clearTimeout(this.exportDpiInputDebounceTimer);
      this.exportDpiInputDebounceTimer = null;
    }
    this.exportPreviewRenderToken += 1;
    this.setExportPreviewStatus('', false);
  };

  ScaleBarBuilder.prototype.handleExportModalFieldUpdate = function (options) {
    if (!this.controls) {
      return;
    }
    var opts = options && typeof options === 'object' ? options : {};
    var self = this;
    var apply = function (normalizeControlValue) {
      var rawDpiValue = self.controls.exportPdfDpi ? String(self.controls.exportPdfDpi.value || '').trim() : '';
      var current = self.getExportPdfSettings();
      var nextDpi = current.dpi;
      if (rawDpiValue !== '') {
        var parsedDpi = parseFloat(rawDpiValue);
        if (Number.isFinite(parsedDpi)) {
          nextDpi = Math.round(clamp(parsedDpi, 96, 1200));
        }
      }
      var nextMode = self.controls.exportPdfMode ? self.controls.exportPdfMode.value : current.mode;
      var nextFormat = self.controls.exportFormat ? self.controls.exportFormat.value : current.format;
      self.state.exportPdfSettings = self.sanitizeExportPdfSettings({
        dpi: nextDpi,
        mode: nextMode,
        format: nextFormat
      });
      if (normalizeControlValue) {
        self.syncExportModalControlsFromState();
      }
      self.updateExportPdfEffectiveDpiNote();
      self.queueExportPdfPreview();
    };

    if (opts.fromDpiInput && !opts.immediate) {
      if (this.exportDpiInputDebounceTimer) {
        clearTimeout(this.exportDpiInputDebounceTimer);
      }
      this.exportDpiInputDebounceTimer = window.setTimeout(function () {
        self.exportDpiInputDebounceTimer = null;
        apply(false);
      }, 320);
      return;
    }

    if (this.exportDpiInputDebounceTimer) {
      clearTimeout(this.exportDpiInputDebounceTimer);
      this.exportDpiInputDebounceTimer = null;
    }
    apply(true);
  };

  ScaleBarBuilder.prototype.queueExportPdfPreview = function () {
    if (!this.isExportPdfModalOpen()) {
      return;
    }
    if (this.exportPreviewDebounceTimer) {
      clearTimeout(this.exportPreviewDebounceTimer);
      this.exportPreviewDebounceTimer = null;
    }
    var self = this;
    var token = ++this.exportPreviewRenderToken;
    this.exportPreviewDebounceTimer = window.setTimeout(function () {
      self.exportPreviewDebounceTimer = null;
      self.updateExportPdfPreview(token);
    }, 140);
  };

  ScaleBarBuilder.prototype.updateExportPdfPreview = function (token) {
    if (!this.isExportPdfModalOpen()) {
      return;
    }
    if (Number.isFinite(parseNumber(token, NaN)) && token !== this.exportPreviewRenderToken) {
      return;
    }
    var previewCanvas = this.controls && this.controls.exportPreviewCanvas;
    if (!previewCanvas) {
      return;
    }
    var previewCtx = previewCanvas.getContext('2d');
    if (!previewCtx) {
      this.setExportPreviewStatus('Preview unavailable: canvas context could not be created.', true);
      return;
    }

    var paper = this.getPaper();
    var wrap = this.controls && this.controls.exportPreviewWrap ? this.controls.exportPreviewWrap : null;
    var fallbackW = 520;
    var fallbackH = Math.min(700, Math.max(320, Math.floor((window.innerHeight || 900) * 0.68)));
    var maxW = wrap ? Math.max(220, Math.floor(wrap.clientWidth - 8)) : fallbackW;
    var maxH = wrap ? Math.max(220, Math.floor(wrap.clientHeight - 8)) : fallbackH;
    var paperW = Math.max(1, parseNumber(paper.width, 210));
    var paperH = Math.max(1, parseNumber(paper.height, 297));
    var fitScale = Math.min(maxW / paperW, maxH / paperH);
    if (!Number.isFinite(fitScale) || fitScale <= 0) {
      fitScale = 1;
    }
    var targetW = Math.max(120, Math.floor(paperW * fitScale));
    var targetH = Math.max(120, Math.floor(paperH * fitScale));
    var ratioError = Math.abs((targetW / targetH) - (paperW / paperH));
    if (ratioError > 0.0001) {
      targetH = Math.max(120, Math.round(targetW * (paperH / paperW)));
    }

    var dpr = Math.max(1, parseNumber(window.devicePixelRatio, 1));
    var backingW = Math.max(1, Math.round(targetW * dpr));
    var backingH = Math.max(1, Math.round(targetH * dpr));
    if (previewCanvas.width !== backingW || previewCanvas.height !== backingH) {
      previewCanvas.width = backingW;
      previewCanvas.height = backingH;
    }

    previewCanvas.style.width = targetW + 'px';
    previewCanvas.style.height = targetH + 'px';

    previewCtx.clearRect(0, 0, backingW, backingH);
    this.renderScene(previewCtx, {
      widthPx: backingW,
      heightPx: backingH,
      paddingPx: 0,
      exportMode: true
    });
    this.updateExportPdfEffectiveDpiNote();
    this.setExportPreviewStatus('Preview updates automatically as you change settings.', false);
  };

  ScaleBarBuilder.prototype.makeExportCanvas = function (dpi) {
    var paper = this.getPaper();
    var safeDpi = this.getSafeExportDpi(dpi, paper);
    var pixelsPerMm = safeDpi / mmPerIn;
    var canvas = document.createElement('canvas');

    canvas.width = Math.max(1, Math.round(paper.width * pixelsPerMm));
    canvas.height = Math.max(1, Math.round(paper.height * pixelsPerMm));

    var ctx = canvas.getContext('2d');
    if (!ctx) {
      throw new Error('Unable to create export canvas context.');
    }
    this.renderScene(ctx, {
      widthPx: canvas.width,
      heightPx: canvas.height,
      pixelsPerMm: pixelsPerMm,
      paddingPx: 0,
      exportMode: true
    });
    canvas._sbbExportDpi = safeDpi;
    canvas._sbbRequestedDpi = dpi;

    return canvas;
  };

  ScaleBarBuilder.prototype.makeExportLayerCanvas = function (dpi, transparent, drawFn) {
    var paper = this.getPaper();
    var safeDpi = this.getSafeExportDpi(dpi, paper);
    var pixelsPerMm = safeDpi / mmPerIn;
    var canvas = document.createElement('canvas');
    canvas.width = Math.max(1, Math.round(paper.width * pixelsPerMm));
    canvas.height = Math.max(1, Math.round(paper.height * pixelsPerMm));
    var ctx = canvas.getContext('2d');
    if (!ctx) {
      throw new Error('Unable to create export layer context.');
    }
    if (!transparent) {
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
    } else {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
    }
    var view = {
      fitScale: pixelsPerMm,
      scale: pixelsPerMm,
      originX: 0,
      originY: 0
    };
    var prevExport = this.isExportRender;
    var prevSceneAlpha = this.sceneVisualAlpha;
    this.isExportRender = true;
    this.sceneVisualAlpha = 1;
    try {
      drawFn.call(this, ctx, view, paper);
    } finally {
      this.isExportRender = prevExport;
      this.sceneVisualAlpha = prevSceneAlpha;
    }
    canvas._sbbExportDpi = safeDpi;
    canvas._sbbRequestedDpi = dpi;
    return canvas;
  };

  ScaleBarBuilder.prototype.makeExportRasterUnderlayCanvas = function (dpi) {
    return this.makeExportLayerCanvas(dpi, false, function (ctx, view, paper) {
      var points = this.getCurrentPoints();
      this.drawPaperBackground(ctx, view, paper);
      this.drawBackgroundNoise(ctx, view, points, paper);
    });
  };

  ScaleBarBuilder.prototype.isRasterOverlayItem = function (item) {
    if (!item || item.visible === false) {
      return false;
    }
    if (item.type !== 'image' && item.type !== 'logo') {
      return false;
    }
    return !!(item.srcDataUrl && String(item.srcDataUrl).trim());
  };

  ScaleBarBuilder.prototype.drawHybridVectorScene = function (pdfCtx, paper, pixelsPerMm) {
    var exportPixelsPerMm = Math.max(0.0001, parseNumber(pixelsPerMm, 1));
    var view = {
      // Keep export sizing behavior aligned with bitmap export (px-per-mm),
      // then project px-space back into mm by inverse-scaling the PDF context.
      fitScale: exportPixelsPerMm,
      scale: exportPixelsPerMm,
      originX: 0,
      originY: 0
    };
    var tags = this.getActiveTags();
    var points = this.getCurrentPoints();
    var prevExport = this.isExportRender;
    var prevSceneAlpha = this.sceneVisualAlpha;

    this.isExportRender = true;
    this.sceneVisualAlpha = 1;
    this.hitRegions = [];
    var didTransform = false;
    if (pdfCtx && typeof pdfCtx.save === 'function' && typeof pdfCtx.scale === 'function') {
      pdfCtx.save();
      pdfCtx.scale(1 / exportPixelsPerMm, 1 / exportPixelsPerMm);
      didTransform = true;
    }
    try {
      if (this.state.showDistances) {
        this.drawDistanceLabels(pdfCtx, view, tags, {
          drawLines: true,
          drawLabels: false,
          addLineHits: false,
          addLabelHits: false
        });
      }
      this.drawReferenceBars(pdfCtx, view, paper, points);
      if (this.state.showDistances) {
        this.drawDistanceLabels(pdfCtx, view, tags, {
          drawLines: false,
          drawLabels: true,
          addLineHits: false,
          addLabelHits: false
        });
      }
      this.drawAprilTagQuietZones(pdfCtx, view, tags);
      this.drawCircularTagQuietZones(pdfCtx, view, tags);
      for (var i = 0; i < tags.length; i += 1) {
        this.drawTag(pdfCtx, view, paper, tags[i], i);
      }
      this.drawHomeCrosshair(pdfCtx, view, paper);
      this.drawCutLines(pdfCtx, view, points, paper);
    } finally {
      if (didTransform && pdfCtx && typeof pdfCtx.restore === 'function') {
        pdfCtx.restore();
      }
      this.isExportRender = prevExport;
      this.sceneVisualAlpha = prevSceneAlpha;
    }
  };

  ScaleBarBuilder.prototype.drawSingleOverlayToVectorPdf = function (pdfCtx, paper, overlayItem, pixelsPerMm) {
    var exportPixelsPerMm = Math.max(0.0001, parseNumber(pixelsPerMm, 1));
    var view = {
      fitScale: exportPixelsPerMm,
      scale: exportPixelsPerMm,
      originX: 0,
      originY: 0
    };
    var tags = this.getActiveTags();
    var originalOverlays = this.state.overlayItems;
    var prevExport = this.isExportRender;
    var prevSceneAlpha = this.sceneVisualAlpha;
    this.isExportRender = true;
    this.sceneVisualAlpha = 1;
    this.state.overlayItems = [overlayItem];
    var didTransform = false;
    if (pdfCtx && typeof pdfCtx.save === 'function' && typeof pdfCtx.scale === 'function') {
      pdfCtx.save();
      pdfCtx.scale(1 / exportPixelsPerMm, 1 / exportPixelsPerMm);
      didTransform = true;
    }
    try {
      this.drawOverlayItems(pdfCtx, view, paper, tags);
    } finally {
      if (didTransform && pdfCtx && typeof pdfCtx.restore === 'function') {
        pdfCtx.restore();
      }
      this.state.overlayItems = originalOverlays;
      this.isExportRender = prevExport;
      this.sceneVisualAlpha = prevSceneAlpha;
    }
  };

  ScaleBarBuilder.prototype.drawSingleOverlayToRasterPdf = function (pdf, paper, overlayItem, dpi) {
    var overlayCanvas = this.makeExportLayerCanvas(dpi, true, function (ctx, view, paperArg) {
      var originalOverlays = this.state.overlayItems;
      this.state.overlayItems = [overlayItem];
      try {
        this.drawOverlayItems(ctx, view, paperArg, this.getActiveTags());
      } finally {
        this.state.overlayItems = originalOverlays;
      }
    });
    pdf.addImage(overlayCanvas.toDataURL('image/png'), 'PNG', 0, 0, paper.width, paper.height, undefined, 'FAST');
  };

  ScaleBarBuilder.prototype.drawHybridOverlayStack = function (pdf, paper, settings, pixelsPerMm) {
    var overlays = Array.isArray(this.state.overlayItems) ? this.state.overlayItems.slice() : [];
    overlays = overlays.filter(function (item) {
      return !!(item && item.visible !== false);
    }).sort(function (a, b) {
      return parseNumber(a && a.zIndex, 0) - parseNumber(b && b.zIndex, 0);
    });
    if (!overlays.length) {
      return;
    }
    var pdfCtx = pdf.context2d;
    for (var i = 0; i < overlays.length; i += 1) {
      var overlay = overlays[i];
      if (this.isRasterOverlayItem(overlay)) {
        this.drawSingleOverlayToRasterPdf(pdf, paper, overlay, settings.dpi);
      } else {
        this.drawSingleOverlayToVectorPdf(pdfCtx, paper, overlay, pixelsPerMm);
      }
    }
  };

  ScaleBarBuilder.prototype.downloadBlobUrl = function (blobUrl, filename) {
    var link = document.createElement('a');
    link.href = blobUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  ScaleBarBuilder.prototype.getExportBaseName = function () {
    var paper = this.state.paperSize.toLowerCase();
    return 'scale-bar-' + this.state.softwarePreset.toLowerCase() + '-' + this.state.tagFamily.toLowerCase() + '-' + paper;
  };

  ScaleBarBuilder.prototype.exportRasterImage = function (format, dpi) {
    var outFormat = String(format || 'png').toLowerCase();
    if (outFormat !== 'jpg' && outFormat !== 'jpeg') {
      outFormat = 'png';
    } else {
      outFormat = 'jpg';
    }
    var canvas = null;
    try {
      canvas = this.makeExportCanvas(dpi);
    } catch (exportError) {
      this.setStatus(
        (outFormat === 'jpg' ? 'JPG' : 'PNG') +
        ' export failed: ' +
        (exportError && exportError.message ? exportError.message : 'unknown error') +
        '.',
        true
      );
      return false;
    }
    var url = outFormat === 'jpg'
      ? canvas.toDataURL('image/jpeg', 0.92)
      : canvas.toDataURL('image/png');
    this.downloadBlobUrl(url, this.getExportBaseName() + '.' + outFormat);
    var exportedDpi = parseNumber(canvas._sbbExportDpi, dpi);
    var paper = this.getPaper();
    var requestedDpi = Math.round(clamp(parseNumber(dpi, 300), 96, 1200));
    var dpiNote = exportedDpi < requestedDpi
      ? (' (auto-limited from ' + requestedDpi + ' DPI for device compatibility)')
      : '';
    this.setStatus(
      (outFormat === 'jpg' ? 'JPG' : 'PNG') +
      ' exported at ' + Math.round(exportedDpi) +
      ' DPI for ' + toFixedTrim(paper.width, 1) + ' x ' + toFixedTrim(paper.height, 1) + ' mm.' +
      dpiNote,
      false
    );
    return true;
  };

  ScaleBarBuilder.prototype.exportPng = function () {
    this.exportRasterImage('png', 300);
  };

  ScaleBarBuilder.prototype.exportPdfBitmap = function (settings) {
    if (!window.jspdf || !window.jspdf.jsPDF) {
      this.setStatus('PDF export unavailable: jsPDF not loaded.', true);
      return false;
    }
    var paper = this.getPaper();
    var orientation = this.state.paperOrientation === 'landscape' ? 'landscape' : 'portrait';
    var canvas = this.makeExportCanvas(settings.dpi);
    var dataUrl = canvas.toDataURL('image/png');
    var jsPDF = window.jspdf.jsPDF;
    var pdf = new jsPDF({
      orientation: orientation,
      unit: 'mm',
      format: this.getJsPdfFormat(),
      compress: true,
      floatPrecision: 16
    });
    pdf.addImage(dataUrl, 'PNG', 0, 0, paper.width, paper.height, undefined, 'FAST');
    pdf.save(this.getExportBaseName() + '.pdf');

    var exportedDpi = parseNumber(canvas._sbbExportDpi, settings.dpi);
    var dpiNote = exportedDpi < settings.dpi
      ? (' Export DPI auto-limited to ' + Math.round(exportedDpi) + ' due canvas limits.')
      : '';
    this.setStatus('Bitmap PDF exported at 1:1 page size (' + toFixedTrim(paper.width, 1) + ' x ' + toFixedTrim(paper.height, 1) + ' mm).' + dpiNote + ' Print at Actual Size (100%).');
    return true;
  };

  ScaleBarBuilder.prototype.exportPdfHybridVector = function (settings) {
    if (!window.jspdf || !window.jspdf.jsPDF) {
      this.setStatus('PDF export unavailable: jsPDF not loaded.', true);
      return false;
    }

    var paper = this.getPaper();
    var orientation = this.state.paperOrientation === 'landscape' ? 'landscape' : 'portrait';
    var jsPDF = window.jspdf.jsPDF;
    var pdf = new jsPDF({
      orientation: orientation,
      unit: 'mm',
      format: this.getJsPdfFormat(),
      compress: true,
      floatPrecision: 16
    });

    var underlayCanvas = null;
    try {
      underlayCanvas = this.makeExportRasterUnderlayCanvas(settings.dpi);
    } catch (exportError) {
      this.setStatus('Hybrid export failed while preparing raster layers: ' + (exportError && exportError.message ? exportError.message : 'unknown error') + '.', true);
      return false;
    }

    if (underlayCanvas) {
      pdf.addImage(underlayCanvas.toDataURL('image/png'), 'PNG', 0, 0, paper.width, paper.height, undefined, 'FAST');
    }

    var vectorDpi = Math.max(96, parseNumber(underlayCanvas && underlayCanvas._sbbExportDpi, this.getSafeExportDpi(settings.dpi, paper)));
    var vectorPixelsPerMm = Math.max(0.0001, vectorDpi / mmPerIn);
    var hasVectorContext = !!(pdf.context2d && typeof pdf.context2d.save === 'function' && typeof pdf.context2d.fillRect === 'function');
    if (hasVectorContext) {
      var prevVectorPdfRender = !!this.isVectorPdfRender;
      var prevVectorPdfScale = parseNumber(this.vectorPdfExportScale, 1);
      this.isVectorPdfRender = true;
      this.vectorPdfExportScale = vectorPixelsPerMm;
      try {
        if (typeof pdf.context2d.autoPaging !== 'undefined') {
          // Prevent context2d from creating additional pages while drawing.
          pdf.context2d.autoPaging = false;
        }
        this.drawHybridVectorScene(pdf.context2d, paper, vectorPixelsPerMm);
        this.drawHybridOverlayStack(pdf, paper, settings, vectorPixelsPerMm);
        var prevExport = this.isExportRender;
        var prevSceneAlpha = this.sceneVisualAlpha;
        this.isExportRender = true;
        this.sceneVisualAlpha = 1;
        var didTransform = false;
        if (typeof pdf.context2d.save === 'function' && typeof pdf.context2d.scale === 'function') {
          pdf.context2d.save();
          pdf.context2d.scale(1 / vectorPixelsPerMm, 1 / vectorPixelsPerMm);
          didTransform = true;
        }
        try {
          this.drawAttribution(pdf.context2d, {
            fitScale: vectorPixelsPerMm,
            scale: vectorPixelsPerMm,
            originX: 0,
            originY: 0
          }, paper);
        } finally {
          if (didTransform && typeof pdf.context2d.restore === 'function') {
            pdf.context2d.restore();
          }
          this.isExportRender = prevExport;
          this.sceneVisualAlpha = prevSceneAlpha;
        }
      } catch (vectorError) {
        if (typeof console !== 'undefined' && console.warn) {
          console.warn('Hybrid vector pass failed, falling back to bitmap export.', vectorError);
        }
        this.isVectorPdfRender = prevVectorPdfRender;
        this.vectorPdfExportScale = prevVectorPdfScale;
        return this.exportPdfBitmap(settings);
      } finally {
        this.isVectorPdfRender = prevVectorPdfRender;
        this.vectorPdfExportScale = prevVectorPdfScale;
      }
    } else {
      return this.exportPdfBitmap(settings);
    }

    pdf.save(this.getExportBaseName() + '.pdf');
    var exportedDpi = underlayCanvas ? parseNumber(underlayCanvas._sbbExportDpi, settings.dpi) : settings.dpi;
    var dpiNote = exportedDpi < settings.dpi ? (' Raster layers were limited to ' + Math.round(exportedDpi) + ' DPI due canvas limits.') : '';
    this.setStatus('Hybrid vector PDF exported at 1:1 page size (' + toFixedTrim(paper.width, 1) + ' x ' + toFixedTrim(paper.height, 1) + ' mm).' + dpiNote + ' Print at Actual Size (100%).');
    return true;
  };

  ScaleBarBuilder.prototype.exportPdfFromModalSettings = function () {
    var settings = this.getExportPdfSettings();
    var format = settings.format || 'pdf';
    var ok = false;
    try {
      if (format === 'png' || format === 'jpg') {
        ok = this.exportRasterImage(format, settings.dpi);
      } else if (settings.mode === 'bitmap') {
        ok = this.exportPdfBitmap(settings);
      } else {
        ok = this.exportPdfHybridVector(settings);
      }
    } catch (error) {
      var formatLabel = String(format || 'pdf').toUpperCase();
      this.setStatus(formatLabel + ' export failed: ' + (error && error.message ? error.message : 'unknown error') + '.', true);
      ok = false;
    }
    if (ok) {
      this.closeExportPdfModal();
    }
    return ok;
  };

  ScaleBarBuilder.prototype.exportPdf = function () {
    this.openExportPdfModal();
  };
})();
